/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscriptionalertpurchaseunavailableuserbanned5Inputs */



/**
* | output |
* | --- |
* | "RuStore has restricted payments for your account. Please contact RuStore support." |
*
* @param {Subscriptionalertpurchaseunavailableuserbanned5Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscriptionalertpurchaseunavailableuserbanned5 = /** @type {((inputs?: Subscriptionalertpurchaseunavailableuserbanned5Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscriptionalertpurchaseunavailableuserbanned5Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("RuStore has restricted payments for your account. Please contact RuStore support.")
	if (locale === "es") return /** @type {LocalizedString} */ ("RuStore ha restringido los pagos de tu cuenta. Contacta con el soporte de RuStore.")
	return /** @type {LocalizedString} */ ("RuStore ограничил оплату для вашего аккаунта. Обратитесь в поддержку RuStore.")
});
export { subscriptionalertpurchaseunavailableuserbanned5 as "subscriptionAlertPurchaseUnavailableUserBanned" }